/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * French Language Resource file.
 *
 * @author Hari Gangadharan
 */
const RESOURCES = {
  'common.OK': 'Ok',
  'common.CONTINUE': 'Continuer',
  'browser.check.DONT_SHOW_AGAIN': 'Ne plus afficher',
  'browser.check.SYS_REQUIREMENTS_LINK_TEXT': 'un système d\'exploitation et un navigateur officiellement supportés',
  'browser.check.BROWSER_MESSAGE_TITLE': 'La version de votre navigateur <<name>> n\'est pas prise en charge',
  'browser.check.BROWSER_MESSAGE_DESC': 'Pour une expérience optimale, utilisez l\'un des navigateurs suivants:',
  'browser.check.BROWSER_UNSUPPORTED_TITLE': 'Votre navigateur <<name>> n\'est pas supporté',
  'browser.check.BROWSER_UNSUPPORTED_DESC': 'Pour une expérience optimale, choisissez un des navigateurs '
    + 'officiellement supportés.',
  'browser.check.BROWSER_SKIP_NOW': 'Passer pour l\'instant"',
  'browser.check.BROWSER_SUPPORTED_LINK_TEXT': 'À propos des navigateurs supportés',
  'browser.check.OS_UNSUPPORTED_TITLE': 'Votre système d\'exploitation <<name>> n\'est pas supporté',
  'browser.check.OS_UNSUPPORTED_DESC': 'Bien que ce produit puisse fonctionner sans problème, sachez que les problèmes '
    + 'que vous pourriez rencontrer pourraient être résolus en utilisant un appareil qui fonctionne avec <<link>>.',
  'errors.GENERIC_TITLE': 'Erreur Serveur',
  'errors.GENERIC_DESC': 'Désolé, notre système est hors service. '
    + 'Veuillez réessayer plus tard ou contacter le support.',
  'errors.HTTP_400_TITLE': 'Erreur Serveur',
  'errors.HTTP_400_DESC': 'Désolé, notre système est hors service. '
    + 'Veuillez réessayer plus tard ou contacter le support.',
  'errors.HTTP_401_TITLE': 'Êtes-vous connecté ?',
  'errors.HTTP_401_DESC': 'Nous ne pouvons pas récupérer les données car la session'
    + ' de votre connexion doit être expirée.',
  'errors.HTTP_403_TITLE': 'Non autorisé',
  'errors.HTTP_403_DESC': 'L\'accès à cette ressource n\'est pas autorisé.',
  'errors.HTTP_888_TITLE': 'Le serveur était trop lent pour répondre',
  'errors.HTTP_888_DESC': 'Nous avons rencontré une erreur lors du traitement de votre demande'
};

export default RESOURCES;
